import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _450px,
} from "../../utils/mediaBreakpoints";
import securityImg from "../../assets/image/securityImg.png";
import { se } from "react-day-picker/locale";

const SecurityTop = ({ data, isMobile }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const text = "Where Trust Meets Technology\nEngineered for Legal Precision";
  return (
    <>
      <div className="row p-5">
        <div className="col-12" style={{ background: "#090D24" }}>
          <div className="d-flex align-items-center justify-content-center">
            <div
              className={`fw800  text-center text-white lh-1`}
              style={{
                // lineHeight: _450
                //   ? "1.2rem"
                //   : _576
                //   ? "1.5rem"
                //   : _768
                //   ? "1.5rem"
                //   : _992
                //   ? "2rem"
                //   : _1200
                //   ? "2.5rem"
                //   : _1400
                //   ? "3rem"
                //   : _1600
                //   ? "4rem"
                //   : _1700
                //   ? "4.5rem"
                //   : _1800
                //   ? "5rem"
                //   : "5rem",
                fontSize: _450
                  ? "25px"
                  : _576
                  ? "25px"
                  : _768
                  ? "25px"
                  : _992
                  ? "30px"
                  : _1200
                  ? "35px"
                  : _1400
                  ? "45px"
                  : _1600
                  ? "55px"
                  : _1700
                  ? "60px"
                  : _1800
                  ? "70px"
                  : "70px",
              }}
              dangerouslySetInnerHTML={{
                __html: _576
                  ? data?.heading?.split("\n")?.map((line, index) => {
                      const color = index === 0 ? "#FFFFFF" : "#459EFF";
                      const cleanLine = line.replace(/^#\s*/, "");
                      return `<span style="color: ${color}">${cleanLine}</span>`;
                    }).join(" ")
                  : data?.heading
                      ?.split("\n")
                      .map((line, index) => {
                        const color = index === 0 ? "#FFFFFF" : "#459EFF";
                        const cleanLine = line.replace(/^#\s*/, "");
                        return `<span style="color: ${color}">${cleanLine}</span>`;
                      })
                      .join("<br />"),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export const SecurityCarousel = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  return (
    <>
      <div className="row">
        <Carousel
          pause={false}
          indicators={false}
          interval={5000}
          controls={false}
          className="p-0"
        >
          {data?.carousel?.map((image, idx) => (
            <Carousel.Item key={idx} className="position-relative ">
              <img
                className="d-block w-100 "
                style={{ objectFit: "fill", overflow: "hidden" }}
                //   src={`${baseUrl}${image?.background?.url}`}
                src={securityImg}
                alt="..."
              />

              <div
                className=" w-100 position-absolute"
                style={{ top: "55%", left: "10%" }}
              >
                <p
                  className="fw700 text-start text-white  "
                  dangerouslySetInnerHTML={{
                    __html: image?.description?.split("\n").join("<br/>"),
                  }}
                  style={{
                    fontSize: _450
                      ? "16px"
                      : _576
                      ? "20px"
                      : _768
                      ? "25px"
                      : _992
                      ? "25px"
                      : _1200
                      ? "30px"
                      : _1400
                      ? "25px"
                      : _1600
                      ? "30px"
                      : _1700
                      ? "30px"
                      : _1800
                      ? "40px"
                      : "40px",
                  }}
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default SecurityTop;
